export default "__VITE_ASSET__d641bc84__"